import React from 'react'

import { twMerge } from 'tailwind-merge'

interface PlaceholderProps {
  children: React.ReactNode
  className?: string
}

/**
 * A reusable empty state placeholder with dashed border styling.
 * Use this for empty states, no results, and placeholder content.
 */
export const Placeholder: React.FC<PlaceholderProps> = ({
  children,
  className,
}) => {
  return (
    <div
      className={twMerge(
        'flex flex-col items-center justify-center text-center',
        'py-12 px-8 rounded-lg',
        'border border-dashed border-primary-200 dark:border-primary-800',
        'bg-primary-50 dark:bg-primary-900/30',
        className,
      )}
    >
      {children}
    </div>
  )
}
